import React, {
  Children,
  forwardRef,
  useMemo,
} from 'react';
import { List, type RowComponentProps } from 'react-window';

const LISTBOX_PADDING = 8; // px
const ITEM_SIZE = 48; // px

type RowProps = { items: React.ReactElement[] };

function Row({ index, style, items }: RowComponentProps<RowProps>) {
  const element = items[index] as React.ReactElement<{
    style?: React.CSSProperties;
  }>;

  return React.cloneElement(element, {
    style: {
      ...style,
      top: (style.top as number) + LISTBOX_PADDING,
    },
  });
}

const ListboxComponent = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>((props, ref) => {
  const { children, ...other } = props;
  const items = useMemo(
    () => Children.toArray(children) as React.ReactElement[],
    [children],
  );

  return (
    <div ref={ref} {...other}>
      <List
        rowComponent={Row}
        rowProps={{ items }}
        rowCount={items.length}
        rowHeight={ITEM_SIZE}
        overscanCount={5}
        style={{
          height: Math.min(280, items.length * ITEM_SIZE + 2 * LISTBOX_PADDING),
        }}
      />
    </div>
  );
});

export default ListboxComponent;